import { useNodes } from '@xyflow/react';
import { memo } from 'react';

import { NodeType } from '@/components/flow';

import { ValidationPanelSlideOut } from './ValidationPanelSlideOut.tsx';

export type ValidationPanelWrapperProps = {
  agentId: string;
};

const IValidationPanelWrapper = ({ agentId }: ValidationPanelWrapperProps) => {
  const nodes = useNodes() as NodeType[];
  const selectedNode = nodes.find((node) => node.selected);
  const actionId = selectedNode?.data.resourceIds.find((r) => r.startsWith('cradl:action'));
  const validationId = selectedNode?.data.resourceIds.find((r) => r.startsWith('cradl:validation'));

  if (!actionId || !validationId || !selectedNode || selectedNode.data.resourceGroupType !== 'validation') {
    return null;
  }

  return <ValidationPanelSlideOut agentId={agentId} actionId={actionId} validationId={validationId} />;
};

export const ValidationPanelSlideOutWrapper = memo(IValidationPanelWrapper) as typeof IValidationPanelWrapper;
